import { render, staticRenderFns } from "./CookieSwitcher.vue?vue&type=template&id=78b8494e"
import script from "./CookieSwitcher.vue?vue&type=script&lang=js"
export * from "./CookieSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CookieSwitcher.vue?vue&type=style&index=0&id=78b8494e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports